import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import Label from '../../Labels/Label';
import ChatMessages from "./ChatMessages";
import ChatNewMessage from "./ChatNewMessage";
import ChatConversation from "./ChatConversation";

import "../Chats.css";

const getDirectHistory = (roomSocketId, directHistory) => {
    if (!roomSocketId || !directHistory) {
        return [];
    }

    const history = directHistory.find((h) => h.roomSocketId === roomSocketId);

    return history ? history.messageHistory : [];
};

const ChatPrivate = ({ username, roomSocketId, directHistory, conversationActive, notifyMessage, sessionId, roomId }) => {
    const [messages, setMessages] = useState([]);

    const conversationSocketId = conversationActive ? conversationActive.roomSocketId : null;
    const conversationMessages = getDirectHistory(conversationSocketId, directHistory);

    useEffect(() => {
        setMessages(conversationMessages);
    }, [directHistory, conversationActive]);

    return (
        <div className='row'>
            <Label text={conversationActive ? `Bate-Papo com - ${conversationActive.username}`.toUpperCase() : "CHAT PRIVADO"} />

            <div className="col-md-12 mb-2">
                {!conversationActive ?
                    <ChatConversation /> :
                    <ChatMessages messages={messages} />
                }
            </div>

            <div className="col-md-12 mb-2">
                <ChatNewMessage
                    username={username}
                    roomSocketId={roomSocketId}
                    conversationActive={conversationActive}
                    notifyMessage={notifyMessage}
                    sessionId={sessionId}
                    roomId={roomId}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(ChatPrivate);
